import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchContactRelationships } from 'api/relationships';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { accountQueryKeys } from 'queries/account-query-keys';

const useCurrentContactRelationships = () => {
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();

    return useSuspenseQuery({
        queryKey: accountQueryKeys.contactRelationships(accountId, contact.id),
        queryFn: () => fetchContactRelationships(accountId, contact.id, { limit: 9999 }),
        select: data => data.data ?? [],
    });
};

export { useCurrentContactRelationships };
